import { SegmentItem, type SegmentItemProps } from '@ui/segment/segment-item'
import { clsx } from 'clsx/lite'
import React, { useEffect, useState } from 'react'

export type SegmentProps = {
  items?: SegmentItemProps[]
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  selected?: string
} & React.HTMLAttributes<HTMLElement>

export const Segment: React.FC<SegmentProps> = ({
  items,
  name,
  onChange,
  selected,
  className,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    if (selected) {
      setSelectedValue(selected)
    }
  }, [selected])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event
    setSelectedValue(value)
    if (onChange) {
      onChange(event)
    }
  }

  return (
    <div
      className={clsx(
        'inline-block rounded-md border-[1px] border-solid border-grey-200 bg-background-default p-1',
        className
      )}
      {...props}
    >
      <div className="flex flex-1">
        {items?.map((item, key) => {
          const { disabled, label, value, ...props } = item
          return (
            <SegmentItem
              key={key}
              disabled={disabled}
              role="radiogroup"
              selected={selectedValue === value}
              {...props}
            >
              <input
                checked={selectedValue === value}
                className="absolute -left-[9999px] opacity-0"
                disabled={disabled}
                name={name}
                type="radio"
                value={value}
                onChange={handleChange}
              />
              {label && <span>{label}</span>}
            </SegmentItem>
          )
        })}
      </div>
    </div>
  )
}
